import { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaArrowAltCircleRight, } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';

export default function OrientacionSexual(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [OrientacionSexual, setOrientacionSexual] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10); 
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const columns = [
        {
            name: 'Acciones',
            cell: row => (
            <div>
                <div className="btn-group">
                    <button type="button" className="btn btn-info" onClick={() => EditarAyuda(row)} 
                        data-tooltip-id='tooltiparriba'
                        data-tooltip-content="Editar">
                        <FaArrowAltCircleRight/>
                    </button>
                </div>
                
            </div>
            ),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'7%' },
        { name: 'Orientacion sexual', selector: row => row.oriOrientacionsexual, sortable: true, width: '20%'},
        { name: 'Estado', selector: row => row.oriActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage, filter) => {
        const url = `/parametros/listarorientacionsexual?page=${page}&limit=${rowsPerPage}&filter=${filter || ''}`;
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setOrientacionSexual(result.data);
        setTotalRows(result.meta.total);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const handleFilter = (value) => {
        fetchData(currentPage, perPage, value);
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    function EditarAyuda (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('oriOrientacionsexual', row.oriOrientacionsexual);
        setValue('oriActivo', row.oriActivo);
    };
    const NuevoAyuda = () =>  {
        setValue('id', 0);
        setValue('oriOrientacionsexual', '');
        setValue('oriActivo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarsrientacionsexual';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData(currentPage, perPage);
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('oriOrientacionsexual', '');
        setValue('oriActivo', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Orientacion Sexual</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to="/" >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to="/parametros" >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Orientacion Sexual</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario orientacion sexual</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='oriOrientacionsexual'>Orientacion sexual</label>
                                                <input id='oriOrientacionsexual' {...register('oriOrientacionsexual', { required: true })} 
                                                    className="form-control" 
                                                    placeholder="Identidad"/>
                                                {errors.oriOrientacionsexual && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('oriActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button type="button" className='form-control' onClick={NuevoAyuda}>Nuevo</button>
                                    </div>
                                    <div className='col-md-4'>
                                        <div className="input-group">
                                            <input 
                                                className='form-control' 
                                                type="text" 
                                                placeholder="Buscar" 
                                                value={searchTerm} 
                                                onChange={e => setSearchTerm(e.target.value)} 
                                            />
                                            <div className="input-group-append">
                                                <button 
                                                    className="btn btn-outline-secondary" 
                                                    type="button" 
                                                    onClick={() => handleFilter(searchTerm)}
                                                >
                                                    Buscar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <DataTable
                                    title="Lista de orientaciones sexuales"
                                    columns={columns}
                                    data={OrientacionSexual}
                                    progressPending={Cargando}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationPerPage={perPage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    noDataComponent="No hay datos para mostrar"
                                /> 
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}